export default "__VITE_ASSET__H2FXc0dn__"